<template>
    <breadCrumbs title="Flat Style" main="Buttons" title1="Flat Style" />
    <div class="container-fluid">
            <div class="row">
              <div class="col-sm-12 text-start">
              <flat/>
              <flat2/>
              <flat3/>
              </div>
            </div>
         </div>
</template>
<script>
import flat from "./flatPage.vue"
import flat2 from "./flat2Page.vue"
import flat3 from "./flat3Page.vue"
export default {
    components:{
        flat,
        flat2,
        flat3
    }
}
</script>